module.exports = __webpack_public_path__ + "static/media/LogoFinal_Positivo_Azul.802d3a40.png";